initShopTheLook();
function initShopTheLook() {
  const stlBtns = document.querySelectorAll("[data-stl-tile]");
  const panels = document.querySelectorAll("[data-stl-panel]");

  // Show
  for (const btn of stlBtns) {
    const panel = document.querySelector(
      `.stl-panel[data-stl="${btn.dataset.stl}"]`
    );

    btn.addEventListener("click", () => {
      panel.classList.add("active");

      // Create screen
      screenCreate(panel);
    });
  }

  // Hide
  for (const panel of panels) {
    const close = panel.querySelector(".btn-close");
    close.onclick = () => {
      panel.classList.remove("active");
      screenRemove();
    };
  }

  // Helpers
  function screenCreate(panel) {
    const screen = document.createElement("button");
    screen.classList.add("overlay-screen");
    screen.onclick = () => {
      panel.classList.remove("active");
      screen.remove();
    };
    document.body.appendChild(screen);
  }

  function screenRemove() {
    const screens = document.querySelectorAll(".overlay-screen");
    screens.forEach((s) => {
      s.remove();
    });
  }
}
